import type React from 'react'

import { LinkButton } from './components'
import css from './styles.module.css'

interface Props {
  onCancel: () => void
  onUpdate: () => void
  canceled: boolean
}

const UpdateLabel = 'Update billing information'
const ReactivateLabel = 'Reactivate subscription'

export const BraintreeButtons: React.FC<Props> = ({
  onUpdate,
  onCancel,
  canceled,
}) => {
  const stripeLabel = canceled ? ReactivateLabel : UpdateLabel

  return (
    <div className={css.braintree_buttons}>
      <LinkButton onClick={onUpdate} label={stripeLabel} />
      {!canceled && (
        <LinkButton onClick={onCancel} danger label="Cancel subscription" />
      )}
    </div>
  )
}
